export const communityUserRoles = {
  MEMBER: 'member',
  ADMIN: 'admin',
  MANAGER: 'manager',
  OWNER: 'owner'
};

export const communityAdminRolesArray = ['admin', 'manager', 'owner'];
